export const headers = [
  { field: "id", headerName: "ID", width: 70 , hidden: true},
  { field: "lp_descripcion", headerName: "Descripción", width: 220 },
  {
    field: "lp_tipo_precio",
    headerName: "Tipo De Lista",
    width: 220,
    valueGetter: (params) => params.row.lp_tipo_precio === 0 ? params.row.lp_tipo_precio === 1 ? "Mayorista" : "Minorista":"Costo",
  },
  {
    field: "lp_porc",
    headerName: "Porcentaje",
    width: 150,
  }
];
